"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smoothScroll = void 0;
const smoothScroll = () => {
    try {
        const links = document.querySelectorAll("a[href^='#']");
        for (const link of links) {
            link.addEventListener("click", clickHandler);
        }
        function bodyOffset(element) {
            const bodyRect = document.body.getBoundingClientRect(), elemRect = element.getBoundingClientRect();
            return elemRect.top - bodyRect.top;
        }
        function clickHandler(e) {
            e.preventDefault();
            const href = this.getAttribute("href");
            const offsetTop = bodyOffset(document.querySelector(href));
            // console.log(href);
            // console.log(offsetTop);
            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }
    catch (e) {
        console.error(e);
    }
};
exports.smoothScroll = smoothScroll;
